export default __webpack_public_path__ + "static/media/quotations.90a7755f.svg";